import {useParams} from 'react-router-dom'

const useFavoriteId = () => {
  const {favorite} = useParams()
  return [favorite]
}

export default useFavoriteId
